import React, { lazy, Suspense } from "react";
import {
  Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import { createBrowserHistory } from 'history';

import withCurrentUser from '../hocs/with_current_user.js';
import { compose } from 'redux';

import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';

import theme from '../theme';

const Admin = lazy(() => import("./components/admin.js"));
import Web from "./components/web.js";

import AdminRoutes from "../admin/routes.js";
import WebRoutes from "../web/routes.js";

import CookieAlert from "../base/components/cookie_alert.js";
import ToastContainer from '../base/toasts/toast_container.js';

import XavinRedirectUseCase from "../use_cases/sessions/xavin_redirect_use_case.js";

class MainRouter extends React.Component  {

  constructor(props) {
    super(props);

    this.history = createBrowserHistory();

    this.state = {

    }
  }

  componentDidMount() {
    this.history.replace(location.pathname + location.search + location.hash);
  }

  static getDerivedStateFromProps(props) {
    const { currentUser, adminDashboardAbilityInfo, userOnceLoaded, abilityInfos } = props;
    return {
      currentUser: currentUser,
      adminDashboardAbilityInfo: adminDashboardAbilityInfo,
      userOnceLoaded: userOnceLoaded,
      abilityInfos: abilityInfos
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return JSON.stringify(this.state.currentUser) !== JSON.stringify(nextState.currentUser) ||
           JSON.stringify(this.state.adminDashboardAbilityInfo) !== JSON.stringify(nextState.adminDashboardAbilityInfo) ||
           JSON.stringify(this.state.abilityInfos) !== JSON.stringify(nextState.abilityInfos) ||
           this.state.userOnceLoaded !== nextState.userOnceLoaded;
  }

  pageContent = () => {
    const {
      userOnceLoaded,
      currentUser,
      adminDashboardAbilityInfo: { use: allowAdmin = false } = {}
    } = this.state;
    if(!userOnceLoaded) {
      return <React.Fragment />
    }
    return <Switch>
      <Route path = { `${AdminRoutes.index()}/` }
             render = { () => {
        if(!currentUser || !allowAdmin) {
          return <Redirect to = { WebRoutes.index() } />
        }
        return <Admin />
      }} />
      <Route render = { () => {
        return <Web />
      }} />
    </Switch>
  }

  xavin_redirect = (link) => {
    return XavinRedirectUseCase.execute()
      .then((result) => {
        const { url } = result;
        window.location.href = url + link
      })
      .catch((result) => {
        const { errorData } = result;
        this.setState({
          submit: false,
          errorData: errorData
        });
        this.props.showServerErrorIfNeed(result);
      })
  }

  cookieAlert = () => {
    return <Switch>
      <Route path = { `${AdminRoutes.index()}/` }
             render = { () => {
        $('#xavinKlaro').hide()
        return <React.Fragment />
      }} />
      <Route exact
             sensitive
             path = { `${WebRoutes.dataProtection()}` }
             render = { () => {
        $('#xavinKlaro').hide()
        return <React.Fragment />
      }} />
      <Route exact
        sensitive
        path={`${WebRoutes.termsAndConditions()}`}
        render={() => {
          return this.xavin_redirect("/pdfs/xavin_agb_v1.pdf")
        }} />
      <Route exact
        sensitive
        path={`${WebRoutes.contacts()}`}
        render={() => {
          return this.xavin_redirect("/kontakt")
        }} />
      <Route exact
        sensitive
        path={`${WebRoutes.imprint()}`}
        render={() => {
          // return this.xavin_redirect(WebRoutes.imprint())
          $('#xavinKlaro').hide()
          return <React.Fragment />
        }} />
      <Route render = { () => {
        $('#xavinKlaro').show()
        return <CookieAlert />
      }} />
    </Switch>
  }

  render() {
    return <ThemeProvider theme = { theme } >
      <CssBaseline/>
      <Suspense fallback={<div>loading</div>} >
      <Router history = { this.history }  >
        { this.pageContent() }
        <ToastContainer />
        { this.cookieAlert() }
      </Router>
      </Suspense>
    </ThemeProvider>
  }

}

export default compose(withCurrentUser)(MainRouter);
